export default "/images/aa84c9532a7489f105fd0092f32ad4c5.png";